import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunitySearchComponent } from './community-search.component';
import { SharedModule } from '../shared.module';
import { CommunityServiceInfoModule } from '../community-service-info/community-service-info.module';

@NgModule({
  declarations: [
    CommunitySearchComponent
  ],
  exports: [
    CommunitySearchComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CommunityServiceInfoModule
  ]
})
export class CommunitySearchModule { }
